// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/create_vision_invite.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionMemberRole } from "./vision_membership_pb";
import { file_vision_membership_v1_vision_membership } from "./vision_membership_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/create_vision_invite.proto.
 */
export const file_vision_membership_v1_create_vision_invite: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vbWVtYmVyc2hpcC92MS9jcmVhdGVfdmlzaW9uX2ludml0ZS5wcm90bxIbcHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxItQBChlDcmVhdGVWaXNpb25JbnZpdGVSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5DcmVhdGVWaXNpb25JbnZpdGVSZXF1ZXN0LlBhcmFtcxpoCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRINCgVlbWFpbBgCIAEoCRI7CgRyb2xlGAMgASgOMi0ucHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxLlZpc2lvbk1lbWJlclJvbGUidgoaQ3JlYXRlVmlzaW9uSW52aXRlUmVzcG9uc2USTgoGcmVzdWx0GAEgASgLMj4ucHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxLkNyZWF0ZVZpc2lvbkludml0ZVJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw", [file_vision_membership_v1_vision_membership]);

/**
 * @generated from message protos.vision.membership.v1.CreateVisionInviteRequest
 */
export type CreateVisionInviteRequest = Message<"protos.vision.membership.v1.CreateVisionInviteRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.CreateVisionInviteRequest.Params params = 1;
   */
  params?: CreateVisionInviteRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.CreateVisionInviteRequest.
 * Use `create(CreateVisionInviteRequestSchema)` to create a new message.
 */
export const CreateVisionInviteRequestSchema: GenMessage<CreateVisionInviteRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_create_vision_invite, 0);

/**
 * @generated from message protos.vision.membership.v1.CreateVisionInviteRequest.Params
 */
export type CreateVisionInviteRequest_Params = Message<"protos.vision.membership.v1.CreateVisionInviteRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: protos.vision.membership.v1.VisionMemberRole role = 3;
   */
  role: VisionMemberRole;
};

/**
 * Describes the message protos.vision.membership.v1.CreateVisionInviteRequest.Params.
 * Use `create(CreateVisionInviteRequest_ParamsSchema)` to create a new message.
 */
export const CreateVisionInviteRequest_ParamsSchema: GenMessage<CreateVisionInviteRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_create_vision_invite, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.CreateVisionInviteResponse
 */
export type CreateVisionInviteResponse = Message<"protos.vision.membership.v1.CreateVisionInviteResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.CreateVisionInviteResponse.Result result = 1;
   */
  result?: CreateVisionInviteResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.CreateVisionInviteResponse.
 * Use `create(CreateVisionInviteResponseSchema)` to create a new message.
 */
export const CreateVisionInviteResponseSchema: GenMessage<CreateVisionInviteResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_create_vision_invite, 1);

/**
 * @generated from message protos.vision.membership.v1.CreateVisionInviteResponse.Result
 */
export type CreateVisionInviteResponse_Result = Message<"protos.vision.membership.v1.CreateVisionInviteResponse.Result"> & {
};

/**
 * Describes the message protos.vision.membership.v1.CreateVisionInviteResponse.Result.
 * Use `create(CreateVisionInviteResponse_ResultSchema)` to create a new message.
 */
export const CreateVisionInviteResponse_ResultSchema: GenMessage<CreateVisionInviteResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_create_vision_invite, 1, 0);

